global.logger = console;

import { enableProdMode, importProvidersFrom, enableProfiling, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/components/app.component';
import { FormbirdCommonModule } from './app/modules/common/formbird-common.module';
import { TopBarModule } from './app/modules/top-bar/top-bar.module';
import { FormbirdServicesModule } from '@formbird/services';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PortalModule } from '@angular/cdk/portal';
import { A11yModule } from '@angular/cdk/a11y';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { LightboxModule } from 'ngx-lightbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { ListenServiceWorkerService } from '@services/listen-service-worker';
import { StateChangeService } from '@services/state-change/state-change.service';
import { DocumentModalService } from '@services/modal/document-modal.service';
import { KeyboardShortcutService } from '@services/keyboard-shortcut.service';
import { CustomCSSService } from '@services/custom-css.service';
import { InitialisationService } from '@services/initialisation.service';
import { CacheLoadService } from '@services/cache-load.service';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NewDocumentService } from '@services/document/new-document.service';
import { DocumentListService } from './app/services/document/document-list.service';
import { ImageGalleryService } from '@services/image-gallery.service';
import { ImageLinkService } from '@services/image-link.service';
import { GatewayErrorInterceptorService } from '@services/interceptor/gateway-error-interceptor.service';
import { AuthInterceptorService } from '@services/interceptor/auth-interceptor.service';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { CanDeactivateGuard } from './app/guards/can-deactivate.guard';
import { ModalService } from '@services/modal/modal.service';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { CustomElementService } from '@services/custom-elements/custom-element.service';
import { AngularJSWrapperService } from '@services/angular-js-wrapper/angular-js-wrapper.service';
import { routes } from './app-routing/app.routes';

if (environment.production) {
  enableProdMode();
}

// enable profiling for angular. This is a noop in production mode
enableProfiling();

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(FormsModule, LightboxModule, ReactiveFormsModule, BrowserModule, A11yModule, PortalModule, ScrollingModule, CdkStepperModule, CdkTableModule, CdkTreeModule, FormbirdServicesModule, FormbirdCommonModule, TopBarModule),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    AngularJSWrapperService,
    CustomElementService,
    FormbirdInjectorService,
    ModalService,
    CanDeactivateGuard,
    // turn off http throttling until issue with errors on save, in https://mantis.formbird.com/view.php?id=14769#c55039 ,is solved
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpRequestThrottleInterceptor,
    //   multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GatewayErrorInterceptorService,
      multi: true
    },
    ImageLinkService,
    ImageGalleryService,
    DocumentListService,
    NewDocumentService,
    Location,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    CacheLoadService,
    InitialisationService,
    CustomCSSService,
    KeyboardShortcutService,
    DocumentModalService,
    StateChangeService,
    ListenServiceWorkerService,
    provideHttpClient(withInterceptorsFromDi())
  ]
});
